import React from 'react';
import { FlameIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
const SPOTS_TAKEN = 71;
function TimeBlock({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="flex w-[4.5rem] flex-col items-center rounded-2xl bg-cream-200/70 px-3 py-3 sm:w-20" data-id="element-32" data-mp="3duh0v14dyw9j">
      <span className="font-display text-3xl font-bold tabular-nums text-ember-500" data-id="element-33" data-mp="39rkdkx3wibz9">{value}</span>
      <span className="mt-1 text-[0.6rem] font-bold uppercase tracking-[0.14em] text-forest-700/85" data-id="element-34" data-mp="3nrd00g8ea61f">
        {label}
      </span>
    </div>;
}
export function CountdownSection() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(23 * 3600 + 57 * 60 + 10);
  return <section className="w-full bg-cream-100 px-6 pb-9 pt-2 sm:pb-10" aria-labelledby="countdown-title" data-id="element-35" data-mp="3sjd6ysmvtz7i">
      <div className="mx-auto flex max-w-xl flex-col items-center text-center" data-id="element-36" data-mp="ad8j0h9nrwet">
        <h2 id="countdown-title" className="font-display text-3xl font-bold uppercase tracking-tight text-forest-800 sm:text-4xl" data-id="element-37" data-mp="5ef72ta0sdgr">
          Your Semester Can Be Mapped Today
        </h2>

        <span className="mt-4 inline-flex items-center gap-2 rounded-full bg-cream-200 px-5 py-2 text-[0.7rem] font-bold uppercase tracking-[0.16em] text-forest-700" data-id="element-38" data-mp="1ikkw4j0jh6tl">
          <FlameIcon className="h-3.5 w-3.5 text-ember-500" aria-hidden="true" data-id="element-39" data-mp="1nma6rxjunih5" />
          Launch price closes in
        </span>

        <div className="mt-5 flex justify-center gap-3" role="timer" aria-label={`${hours} hours, ${minutes} minutes and ${seconds} seconds remaining`} data-id="element-40" data-mp="1wl5ifp5nxkru">
          <TimeBlock value={hours} label="Hours" data-id="element-41" data-mp="26ayraief7lse" />
          <TimeBlock value={minutes} label="Min" data-id="element-42" data-mp="26b73e82pyn2j" />
          <TimeBlock value={seconds} label="Sec" data-id="element-43" data-mp="2b9ie0l0u91lt" />
        </div>

        <p className="mt-4 text-sm text-forest-700/85" data-id="element-44" data-mp="2bbusgo7e0tu4">
          After that, the price goes up. It does not return to the launch price.
        </p>

        <div className="mt-5 w-full max-w-md text-left" data-id="element-45" data-mp="2k9opk1cz7ric">
          <div className="flex items-baseline justify-between text-xs font-semibold" data-id="element-46" data-mp="2k83so536vwhb">
            <span className="text-forest-700/85" data-id="element-47" data-mp="l3lvdolz70ug">Launch-price seats</span>
            <span className="text-ember-500" data-id="element-48" data-mp="g7wqd5r6srqr">{SPOTS_TAKEN}% claimed</span>
          </div>
          <div className="mt-2 h-2 w-full overflow-hidden rounded-full bg-cream-300" role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={SPOTS_TAKEN} aria-label="Launch-price seats claimed" data-id="element-49" data-mp="tz1uol5i287f">
            <div className="h-full rounded-full bg-ember-500" style={{
            width: `${SPOTS_TAKEN}%`
          }} data-id="element-50" data-mp="yw1rs6kdg0me" />
          </div>
          <p className="mt-2 text-center text-xs text-forest-700/85" data-id="element-51" data-mp="1cvkw0oa2artf">Only a few seats remain.</p>
        </div>
      </div>
    </section>;
}